import _ from 'lodash';

import { accounts as accountsAPI } from '@/services';

export default {
  data: () => ({
    timeoutThreshold: 1000,
    timeout: {
      promoters: null,
      responsible: null,
      typist: null,
      assignee: null,
    },
    searching: {},
    searchingKeyName: '',
  }),
  methods: {
    // handlers :: search
    handlePromotersSearch(value, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value },
        target: 'promoters',
        method: 'searchPromoters',
      });
    },
    handleResponsibleSearch(value, params, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value, ...params },
        target: 'responsible',
        method: 'searchResponsible',
        id_key: 'user_id',
      });
    },
    handleTypistsSearch(value, params, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value, ...params },
        target: 'typists',
        method: 'searchTypists',
      });
    },

    // search
    callSearch({
      options, target, method, id_key = 'id',
    }) {
      const vm = this;
      if (this.searchingKeyName) this.searching[this.searchingKeyName] = true;

      clearTimeout(this.timeout[target]);
      this.timeout[target] = setTimeout(async () => {
        try {
          const { data } = await accountsAPI[method](options);

          if (!options.search) vm.timeout[target] = null;

          for (const item of data.data.data) {
            vm.list[target].push({
              ...item,
              name: item.name,
              value: item[id_key],
              search: options.search,
            });
          }

          vm.list[target] = _.uniqBy(_.reverse(vm.list[target]), 'value');
        } catch (err) {
          if (this.handlerError) this.handlerError(err);
        } finally {
          if (this.searchingKeyName) this.searching[this.searchingKeyName] = false;
        }
      }, this.timeoutThreshold);
    },
  },
};
